import { algoliasearch, SearchClient } from 'algoliasearch';
import { useMemo } from 'react';

export function useSearchClient(): SearchClient {
  return useMemo(() => algoliasearch(
    import.meta.env.REACT_APP_ALGOLIA_APP_ID,
    import.meta.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
  ), []);
}
